import { VideoStatus, VideoVisibility } from 'js/src/client';
import type { RootState } from 'js/src/libs/RootState';

/* SELECTORS  */
export function isVideoRendering(state: RootState) {
    const video = state.shareVideo.video;
    return [VideoStatus.QUEUED, VideoStatus.PROCESSING].indexOf(video.get('status')) >= 0;
}

export function getSharePageVideo(state: RootState) {
    return state.shareVideo.video;
}

export function selectVideoVisibility(state: RootState) {
    const video = state.shareVideo.video;
    return video.get('visibility') || VideoVisibility.UNLISTED;
}

export const selectVideoProjectId = (state: RootState): number | null => {
    return state.shareVideo.video.get('project_id');
};

export const selectVideoWorkspaceId = (state: RootState): number => {
    return state.shareVideo.video.get('workspace_id');
};
